module.exports = __webpack_public_path__ + "img/iosTip.4bc55111.webp";